import React from 'react'
import PropTypes from 'prop-types'

const TableRow = ({ children, ths, isSingleItem }) => {
  let content = [].concat(children)

  content = (
    <tr>
      {content.map((item, index) =>
        React.cloneElement(item, {
          th: ths[index],
          key: index
        })
      )}
    </tr>
  )

  if (isSingleItem) {
    content = <tbody>{content}</tbody>
  }

  return content
}

TableRow.propTypes = {
  children: PropTypes.any,
  ths: PropTypes.array,
  isSingleItem: PropTypes.bool
}

TableRow.defaultProps = {
  ths: []
}

export default TableRow
